import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Typography } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";

const CandidateDetailsHeader: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="dashboard-page-title">
      <Button
        type="text"
        size="middle"
        icon={<ArrowLeftOutlined />}
        onClick={() => navigate(-1)}
      />
      <Typography.Title level={4} style={{ margin: 0 }}>
        Talent Pool Details
      </Typography.Title>
    </div>
  );
};

export default CandidateDetailsHeader;
